import BaseStore from 'hljd/esm/SearchBar/store'
import Api from '@api/zhiTuiBao'

export default class extends BaseStore {
  $listApi = Api.flowPacketSortList
  $pageSize = 9999

  // operation ，1上移，2下移，3置顶
  changeOrder = async (id, operation) => {
    const { success } = await Api.flowPacketSort({ id, operation })
    if (success) {
      this.$getList()
    }
  }
}
